/**
 * Shared tier gift logic: parse {% render 'tier-addons-json' %} output and qualify lines for /cart/add.js.
 * Used by offer-block (redirect checkout) and product-form (data-redirect).
 */
(function () {
    function parseScriptById(elementId) {
        const el = document.getElementById(elementId);
        if (!el || !String(el.textContent || '').trim()) {
            return [];
        }
        try {
            const data = JSON.parse(el.textContent);
            return Array.isArray(data) ? data : [];
        } catch {
            return [];
        }
    }

    /**
     * @param {Array<{id:number,threshold:number,heading:string,available:boolean,excludeInBogo:boolean,coveredBy:number,types:string[]}>} rows
     * @param {{ totalPrice:number, pendingLineCents:number, cartItems:Array, pendingItems:Array, mainProductType:string }} ctx
     */
    function qualifyGiftLines(rows, ctx) {
        const baseTotal = Number(ctx.totalPrice) || 0;
        const pending = Number(ctx.pendingLineCents) || 0;
        const totalPrice = baseTotal + pending;
        const cartItems = Array.isArray(ctx.cartItems) ? ctx.cartItems : [];
        const pendingItems = Array.isArray(ctx.pendingItems) ? ctx.pendingItems : [];
        const mainProductType = ctx.mainProductType || '';
        const hasPromoLine = [...cartItems, ...pendingItems].some(
            (item) => item.properties && item.properties._promo
        );

        const sorted = [...rows].sort((a, b) => Number(a.threshold) - Number(b.threshold));
        const seen = new Set();
        const lines = [];

        for (const row of sorted) {
            if (!row.available) {
                continue;
            }
            if (row.excludeInBogo && hasPromoLine) {
                continue;
            }
            // A BOGO cart that already holds the BOGO landing pages' own spoon doesn't get the
            // Pearl Spoon tier gift on top (pending items carry the variant as `id`).
            const coveredBy = Number(row.coveredBy) || 0;
            if (
                coveredBy &&
                hasPromoLine &&
                [...cartItems, ...pendingItems].some(
                    (item) => Number(item.variant_id || item.id) === coveredBy
                )
            ) {
                continue;
            }
            const types = Array.isArray(row.types) ? row.types : [];
            const typesOk =
                !types.length ||
                cartItems.some((item) => types.includes(item.product_type)) ||
                (mainProductType && types.includes(mainProductType));
            if (!typesOk) {
                continue;
            }
            // row.threshold is cart subtotal in cents (same as Liquid tier_price / data-threshold).
            // Example: 1000 => $10.00; a $9.99 line is 999 cents and does not qualify.
            if (totalPrice < Number(row.threshold)) {
                continue;
            }
            const vid = Number(row.id);
            if (!vid || seen.has(vid)) {
                continue;
            }
            if (cartItems.some((item) => Number(item.variant_id) === vid)) {
                continue;
            }
            seen.add(vid);
            lines.push({
                id: vid,
                quantity: 1,
                properties: {
                    _tier: row.heading,
                    _required_total: String(row.threshold),
                },
            });
        }
        return lines;
    }

    window.TierAddons = { parseScriptById, qualifyGiftLines };
})();
